var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('a',{class:_vm.active ? 'nav-link active' : 'nav-link'},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }